import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-campaign"
export default class extends Controller {
  static targets = ["user", "platform", "kind", "link", "linkExample", "quantity", "price", "runs", "remarks", "optionCheckbox"]
  static values = { prices: Array }

  connect() {
    this.price_per_one = 0
    this.blankOptions = {
      platform: this.blankOptionText(this.platformTarget),
      kind: this.blankOptionText(this.kindTarget)
    }
  }

  selectUser(event) {
    const userId = event.currentTarget.value

    this.pricesValue = []
    this.resetPlatformSelect()
    this.resetKindSelect()
    this.platformTarget.disabled = true
    this.kindTarget.disabled = true
    this.linkExampleTarget.innerHTML = ""
    this.quantityTarget.value = ""
    this.quantityTarget.disabled = true
    this.priceTarget.value = ""
    this.price_per_one = 0

    if (userId) {
      fetch(`/admin/users/${userId}/prices`)
        .then(response => response.json())
        .then(data => {
          this.pricesValue = data

          this.resetPlatformSelect()

          const seenPlatforms = new Set()
          this.pricesValue.forEach((price) => {
            if (!seenPlatforms.has(price.platform)) {
              this.addOption(this.platformTarget, price.platform, price.platform_name)
              seenPlatforms.add(price.platform)
            }
          })

          if (seenPlatforms.size > 0) {
            this.platformTarget.disabled = false
          }
        })
    }
  }

  selectPlatform(event) {
    const platform = event.currentTarget.value

    this.resetKindSelect()

    if (!this.pricesValue?.length) return

    if (platform) {
      let added = 0
      this.pricesValue.forEach((price) => {
        if (price.platform == platform) {
          this.addOption(this.kindTarget, price.kind, `${price.kind_name}: ${price.amount} ${this.element.dataset.currency}`)
          added += 1
        }
      })

      if (added > 0) {
        this.kindTarget.disabled = false
      }
    }

    this.linkExampleTarget.innerHTML = ""
    this.quantityTarget.value = ""
    this.quantityTarget.disabled = true
    this.priceTarget.value = ""
  }

  selectKind(event) {
    const platform = this.platformTarget.value
    const kind = event.currentTarget.value
    const selected = this.pricesValue.find(price => price.platform == platform && price.kind == kind)

    if (kind && platform && selected) {
      this.selectedPlatformAndKind = selected

      // link example
      this.linkExampleTarget.innerHTML = this.selectedPlatformAndKind.link

      this.price_per_one = this.selectedPlatformAndKind.amount
      if (this.quantityTarget.value) {
        this.priceTarget.value = this.price_per_one * parseInt(this.quantityTarget.value)
      }

      this.quantityTarget.disabled = false
    } else {
      this.selectedPlatformAndKind = null
      this.linkExampleTarget.innerHTML = ""

      this.price_per_one = 0
      this.quantityTarget.value = ""
      this.quantityTarget.disabled = true
      this.priceTarget.value = ""
    }
  }

  changeQuantity(event) {
    this.priceTarget.value = this.price_per_one * parseInt(event.currentTarget.value || 0)
  }

  afterSubmit(event) {
    if (!event.detail.success) return

    // SNSとサービスが未選択の場合はリセットしない
    const platformSelected = this.platformTarget.value
    const kindSelected = this.kindTarget.value
    if (!platformSelected || !kindSelected) return

    this.linkTarget.value = ""
    this.quantityTarget.value = ""
    this.priceTarget.value = ""

    if (this.hasRunsTarget) {
      this.runsTarget.value = ""
    }

    if (this.hasRemarksTarget) {
      this.remarksTarget.value = ""
    }

    if (this.hasOptionCheckboxTarget) {
      this.optionCheckboxTargets.forEach((checkbox) => {
        checkbox.checked = false
      })
    }

    this.quantityTarget.disabled = false

    // 入力開始しやすいようにURL欄へフォーカス
    if (this.hasLinkTarget) {
      window.requestAnimationFrame(() => {
        this.linkTarget.focus()
      })
    }
  }

  resetPlatformSelect() {
    this.resetSelect(this.platformTarget, this.blankOptions.platform)
  }

  resetKindSelect() {
    this.resetSelect(this.kindTarget, this.blankOptions.kind)
    this.kindTarget.disabled = true
  }

  resetSelect(element, blankText) {
    element.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.textContent = blankText
    element.appendChild(option)
    element.value = ""
  }

  addOption(element, value, text) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = text
    element.appendChild(option)
  }

  blankOptionText(element) {
    const option = element.querySelector('option[value=""]')
    return option ? option.textContent.trim() : ""
  }
}
